<!-- <form [formGroup]="form"> -->

<div class="pb-[40px]">
  <div class="flex justify-between mb-[9px] mt-[20px]">
    <h3 class="!pt-[25px] !pl-[50px] text-[black] !m-[0px]">
      Pre-Qualification Questionnaire (PQQ)
    </h3>
    <div class="flex mr-[50px]">
      <button
        (click)="fillResponseForms()"
        type="button"
        class="apply-btn"
      >
        {{!submittedResponse?.company_name ? 'Apply' : 'Edit Response'}}
      </button>
      <button (click)="handleClose()" type="button" class="close-btn">
        Close
      </button>
    </div>
  </div>

  <div class="mx-[50px]">
    <div
      class="header h-[55px] flex justify-start items-center pl-[14px] bg-[#F1F3F5]"
    >
      <p class="!m-0">Project Brief</p>
    </div>
    <div class="w-[100%] pb-[30px] pt-[40px]">
      <app-brief-section></app-brief-section>
      <div
        class="header h-[55px] flex justify-start items-center pl-[14px] mt-[60px] mb-[18px] bg-[#F1F3F5]"
      >
        <p class="!m-0">Selected Work Packages</p>
      </div>

      <div class="w-[50%] mt-[7px] ml-[12px]">
        <div
          *ngIf="
            submittedInitiation?.selected_work_packages.length === 0
          "
          class="w-[100%] !h-[49px] flex justify-between items-center"
        >
          <div class="flex justify-start">
            <p class="packages-name">No work pacakges available</p>
          </div>
        </div>
        <div
          *ngFor="
            let orgDetail of submittedInitiation?.selected_work_packages;
            let i = index
          "
          class="w-[100%] !h-[49px] flex justify-between items-center"
        >
          <div class="flex justify-start">
            <p class="packages-name">{{ orgDetail?.name }}</p>
          </div>
        </div>
      </div>

      <div
        class="header h-[55px] flex justify-start items-center pl-[14px] mt-[60px] mb-[18px] bg-[#F1F3F5]"
      >
        <p class="!m-0">Pre Qualification Questionare</p>
      </div>
      <div
        class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 pl-[14px]"
      >
        <div class="flex items-center">
          <div class="lablel">Reference Number</div>
          <div class="value">{{ submittedInitiation?.reference_number }}</div>
        </div>
        <div class="flex items-center">
          <div class="lablel">Client /Authority</div>
          <div class="value">{{ submittedInitiation?.client }}</div>
        </div>
        <div class="flex items-center">
          <div class="lablel">Date Issued</div>
          <div class="value">{{ submittedInitiation?.issue_date }}</div>
        </div>
        <div class="flex items-center">
          <div class="lablel">Submissions Deadline</div>
          <div class="value">
            {{ submittedInitiation?.submission_deadline }}
          </div>
        </div>
      </div>
    </div>

    <div
      class="header h-[55px] flex justify-between items-center pl-[14px] mt-[60px] mb-[18px] bg-[#F1F3F5]"
    >
      <p class="!m-0">PQQ Application Form</p>
    </div>
    <div class="w-[100%] mt-[15px] pt-[13px]">
      <app-pqq-read-only-form
        [responseSubmitted]="submittedResponse"
      ></app-pqq-read-only-form>
    </div>
    <div
      class="header h-[55px] flex justify-start items-center pl-[14px] mt-0 mb-[18px] bg-[#F1F3F5]"
    >
      <p class="!m-0">Disclaimer</p>
    </div>
    <p class="breif-value">
      The submission of this PQQ does not constitute a binding agreement or
      obligation for the applicant or the issuing organization. The information
      provided in this form is for evaluation purposes only and will be treated
      confidentially. However, the issuing organization reserves the right to
      verify the details provided and may use this information as part of the
      selection process. Submission of this PQQ does not guarantee shortlisting,
      approval, or further communication. The issuing organization reserves the
      right to accept, reject, or request additional information without
      assigning any reason. By submitting this form, the applicant acknowledges
      and agrees to these terms.
    </p>

    <div class="flex">
      <div class="!mr-2">
        <input
          type="checkbox"
          [checked]="submittedResponse?.disclaimer_accepted === 0 ? false : true"
          disabled
        />
      </div>
      <div>
        <p class="!font-normal !text-justify">
          I acknowledge and accept the disclaimer above
        </p>
      </div>
    </div>
    <div style="margin-bottom: 30px !important;">
      <button
        type="button"
        class="apply-btn !bg-[#E76B3F] !text-[#ffffff] !text-[16px] float-end"
        (click)="submittedResponse?.disclaimer_accepted && submitResponse()"
      [ngClass]="submittedResponse?.disclaimer_accepted ? 'cursor-pointer' : 'cursor-no-drop disabled !bg-[#e49172]'"
        [disabled]="!submittedResponse?.disclaimer_accepted"
      >
        Submit
      </button>
    </div>

  </div>
</div>

<ng-container *ngIf="isApplied">
  <app-wrapper
    (handleDialog)="handleDialog()"
    [currentDialog]="currentDialog"
    [isEdit]="isEdit"
    [pqqInputData]="inputData"
  ></app-wrapper>
</ng-container>
